<template>
    <div class="item">
        <div class="wrapper-content">
            <div class="image">
                <img :src="icon" :alt="appName">
            </div>
            <div class="info">
                <div class="name">{{appName}}</div>
                <div class="creator">{{creator}}</div>
            </div>
        </div>
        <div class="wrapper-controls">
            <button class="control-btn">{{controlLabel}}</button>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'notify-dropdown-item',
    props: {
        id: {
            type: String,
            description: 'Id attr'
        },
        icon: {
            type: String,
            description: 'Item App icon',
        },
        appName: {
            type: String,
            description: 'Item App name',
        },
        creator: {
            type: String,
            description: 'Item App creator',
        },
        controlLabel: {
            type: String,
            default: 'Done',
            description: 'Item control name',
        }
    },
};
</script>

<style scoped lang="scss">
    .item {
        display: flex;
        min-width: 364px;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .wrapper-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            .image {
                margin-right: 10px;
                img {
                    border-radius: 9px;
                }
            }
            .info {
                font-weight: 500;
                line-height: 18px;
                .name {
                    color: #333333;
                    font-size: 16px;
                    width: 226px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .creator {
                    color: #636366;
                    font-size: 12px;
                }
            }
        }
        .wrapper-controls {
            .control-btn {
                background: #28A745;
                color: #fff;
                font-weight: 700;
                font-size: 14px;
                border-radius: 20px;
                padding: 6px 16px;
                outline: none;
                &:hover {
                    background: lighten(#28A745, 5%);
                    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
                }
            }
        }
    }
</style>

